// extracted by mini-css-extract-plugin
module.exports = {"container":"H_b","column":"H_b2","wrapper":"H_f","link":"H_b3","socialMedia":"H_b4","icon":"H_bJ"};